import styled from "@emotion/styled";
import { Skeleton } from "@kaltura/mediaspace-shared-styled";

const StyledTagsSkeleton = styled("div")(({ theme }) => ({
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
        marginTop: theme.spacing(2),
    },
}));

const StyledTagSkeleton = styled(Skeleton)(({ theme }) => ({
    borderRadius: theme.kaltura.shape.roundness1,
    marginRight: theme.spacing(2),
    display: "flex",
    height: theme.spacing(4),
    ["&:last-child"]: {
        marginRight: 0,
        flexGrow: 1,
    },
}));

/**
 * global search skeleton - tags skeleton
 */
export const TagsSkeleton = () => {
    return (
        <StyledTagsSkeleton>
            <StyledTagSkeleton variant="rectangular" width={120} height={16} />
        </StyledTagsSkeleton>
    );
};
